import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, toRefs } from 'vue';
import CertificateEducationItem from '@/views/profile/components/CertificateEducationItem.vue';
import useProfileState from '@/state/profile/profileState';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileCertificatesEducationsView',
  props: {
  type: { type: String as PropType<'certificates' | 'educations'>, default: 'certificates' },
},
  setup(__props) {

const props = __props;



const { type } = toRefs(props);
const { profile } = useProfileState();

const list = computed(() => (type.value === 'certificates'
  ? profile.value?.certificates?.certificatesList ?? []
  : profile.value?.educations?.educationsList ?? []));

return { __sfc: true,props, type, profile, list, CertificateEducationItem }
}

})